import styled from '@emotion/styled';

export const Container = styled.div`
	text-align: center;

	.AdsSwiper {
		padding: 3rem;
		display: inline-flex;
		max-width: 120rem;
		width: 100%;

		.swiper-slide {
			box-sizing: border-box;
			padding: 1rem;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
`;

export const Image = styled.div`
	cursor: pointer;
	display: flex;
	flex-direction: column;
	padding: 1rem 1rem 0 1rem;
	background-color: var(--white);
	width: 100%;
	height: 100%;

	> img {
		max-height: 40rem;
	}

	> .skeleton {
		height: 20rem;
	}
`;
